import { useState } from 'react';

const CheckBox = ({ value, children, checkHandler = () => {}, ...props }) => {
    const [checked, setChecked] = useState(value || false);
    const handleCheckboxChange = e => {
        setChecked(e.target.checked);
        checkHandler(e);
    };
    return (
        <input type="checkbox" {...props} checked={checked} onChange={handleCheckboxChange}>
            {children}
        </input>
    );
};

export default CheckBox;
